import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EditDisciplineForm from 'components/Admin/Discipline/EditDisciplineForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';
import _ from 'lodash';

const {
  UPDATE_DISCIPLINE_SAGA
} = constants;

const {
  updateDisciplineSaga,
  cleanErrors,
  loadDisciplineSaga,
  cleanDiscipline
} = actions;

class EditDiscipline extends Component {
  static propTypes = {
    createDiscipline: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      discipline: {
        title: '',
        discipline_type:[]
      }
    }
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.discipline, props.discipline))
      this.setState({
        discipline: {
          ...this.state.discipline,
          ...props.discipline
        }
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadDisciplines(this.props.params.id)
  }

  componentWillUnmount() {
    this.props.cleanDisciplines();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const disciplineData = { ...this.state.discipline,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ discipline: disciplineData });
  }
  onRoleDisciplineChange = (discipline_type) => {
    this.onFieldChange({
      target: {
        name: 'discipline_type',
        value: (discipline_type || []).map(discipline => discipline.value)
      }
    });
  }

  onSubmit = () => {
    this.props.updateDiscipline(this.state.discipline)
  }

  render() {
    const {
      errors,
      errorsFrontend
    } = this.props;
    return (
      <main className="site--width clearfix-c">
        <EditDisciplineForm
          onFieldChange={this.onFieldChange}
          discipline={this.state.discipline}
          onSubmit={this.onSubmit}
          onRoleDisciplineChange={this.onRoleDisciplineChange}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_DISCIPLINE_SAGA],
    errorsFrontend: state.errors[`${UPDATE_DISCIPLINE_SAGA}_FRONTEND`],
    discipline: state.disciplines.admin.tmp
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateDiscipline: (discipline) => dispatch(updateDisciplineSaga(discipline)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_DISCIPLINE_SAGA)),
    loadDisciplines: (id) => dispatch(loadDisciplineSaga(id)),
    dispatch: dispatch,
    cleanDisciplines: () => dispatch(cleanDiscipline())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditDiscipline);



// WEBPACK FOOTER //
// ./src/containers/Admin/Discipline/EditDiscipline.jsx